export default "__VITE_ASSET__CjkNX7Ss__"